<template>
  <div class="nav">
    <div
      v-for="(item, index) in items"
      :key="item.id"
      class="item"
      @click="onItemClickInner(index, item)"
    >
      <div class="S8" :class="item.isSelect ? 'black-color' : 'grey-color'">
        {{ item.name }}
        <span
          class="S4"
          :class="item.isSelect ? 'black-color' : 'grey-color'"
          >{{ item.title }}</span
        >
      </div>
      <div :class="item.isSelect ? 'sel' : ''" class="ind" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    onItemClickInner(index, item) {
      this.items.forEach(function(it) {
        it.isSelect = false
      })
      item.isSelect = true
      this.$emit('onItemClick', index, item)
    }
  }
}
</script>

<style scoped lang="scss">
.nav {
  display: flex;
  flex-direction: row;
  height: 90px;
  align-items: center;
  padding-left: 32px;
  border-bottom: 1px solid #f5f5f5;
  padding-top: 4px;
  background: #fff;
}

.nav .item {
  position: relative;
  margin-right: 66px;
}

.ind {
  height: 6px;
  width: 60%;
  position: absolute;
  left: 20%;
  right: 0px;
  bottom: -24px;
  border-radius: 6px;
}

.sel {
  background: #fa5f55;
}
</style>
